import { GlobalSite } from "types/CMS/KontentAI";
import { TermsAndConditions } from "types/CMS/Unum/GlobalSite/TermsAndCondtions";
import { createResolver } from "../Factories/ResolverFactory";
import { richTextResolver } from "../richText";

export const TermsAndConditionsResolver = createResolver({
  resolve: (data: GlobalSite[]): TermsAndConditions => {
    if (!data) {
      throw new Error("No data provided for Terms and Conditions resolution.");
    }
    const tnc  = data[0].elements.terms_and_conditions.linkedItems[0];
    return {
        title: tnc.elements.title.value,
        intro: richTextResolver.resolve(tnc.elements.intro).result,
        content: richTextResolver.resolve(tnc.elements.body).result,
    }

}});